import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhoWeHelpHero } from "@/components/who-we-help/HeroSection";
import { OverviewSection } from "@/components/who-we-help/OverviewSection";
import { ServiceBusinessesSection } from "@/components/who-we-help/ServiceBusinessesSection";
import { EducationSection } from "@/components/who-we-help/EducationSection";
import { WhyItWorksSection } from "@/components/who-we-help/WhyItWorksSection";
import { CTASection } from "@/components/who-we-help/CTASection";

const WhoWeHelp = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <WhoWeHelpHero />
        <OverviewSection />
        <ServiceBusinessesSection />
        <EducationSection />
        <WhyItWorksSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default WhoWeHelp;
